import * as actionTypes from '../actions/actionTypes';

export const fetchSalesList = (data) => {
    return {
        type: actionTypes.FETCH_SALES_LIST,
        sales: data
    }
}
export const createSale = (data) => {
    return {
        type: actionTypes.CREATE_SALE,
        sale: data
    }
}
export const deleteSale = (id) => {
    return {
        type: actionTypes.DELETE_SALE,
        id
    }
}
export const updateSale = (data) => {
    return {
        type: actionTypes.UPDATE_SALE,
        data
    }
}
export const clearSale = () => {
    return {
        type: actionTypes.CLEAR_SALE
    }
}